export default __webpack_public_path__ + "static/media/compartilharListaParceirosAzul.b7f952c9.svg";